import React, { useEffect, useState } from "react";

interface SearchBoxProps {
  onSearch: (query: string | null) => void;
  placeholder?: string;
  delay?: number;
}

const SearchBox: React.FC<SearchBoxProps> = ({
  onSearch,
  placeholder = "Search...",
  delay = 500,
}) => {
  const [searchTerm, setSearchTerm] = useState<string | null>(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      onSearch(searchTerm);
    }, delay);

    return () => clearTimeout(handler);
  }, [searchTerm, onSearch, delay]);

  const clearSearch = () => {
    setSearchTerm("");
    onSearch("");
  };

  return (
    <div className="search-container">
      <input
        className="search expandright"
        id="searchright"
        type="search"
        name="q"
        placeholder="Search"
        value={searchTerm ?? ""}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <label className="button searchbutton" htmlFor="searchright">
        <span className="mglass" aria-label="Open search">
          &#9906;
        </span>
      </label>
    </div>
  );
};

export default SearchBox;
